module.exports = __webpack_public_path__ + "img/pro_four.21562dee.jpg";